import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";

const Facility = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Header toggleSidebar={() => setOpen(true)} />

            <Sidebar
                isOpen={open}
                close={() => setOpen(false)}
            />

            <main className="page-wrapper">

                {/* HERO */}

                <div className="about-hero">

                    <div className="about-overlay">

                        <h1>FACILITY</h1>

                        <Breadcrumb />

                    </div>

                </div>


                {/* PAGE CONTENT */}

                <div className="container contact-page">

                    <div className="vision-card overview-card">


                        {/* HEADER */}

                        <div className="overview-header">

                            <h2>
                                SCHOOL FACILITY
                            </h2>

                            <div className="overview-title-line"></div>

                        </div>


                        {/* SCHOOL INTRODUCTION */}

                        <div className="overview-content">

                            <p>
                                Nav Jeevan Mission School, Anandnagar is a
                                CBSE-affiliated English-medium senior secondary
                                school offering education from the foundational
                                years through Class XII. The school focuses on
                                academic excellence, character formation,
                                leadership and holistic development.
                            </p>


                            {/* MAJOR SCHOOL FACILITIES */}

                            <div className="overview-section">

                                <div className="overview-section-heading">

                                    <h3>
                                        🌟 Major School Facilities
                                    </h3>

                                </div>

                            </div>


                            {/* 1. SMART CLASSROOMS */}

                            <div className="overview-section">

                                <div className="overview-section-heading">

                                    <h3>
                                        1. Smart Classrooms &amp; Digital Learning
                                    </h3>

                                </div>

                                <p>
                                    The school provides technology-enabled
                                    learning facilities that make classroom
                                    teaching interactive and engaging.
                                </p>

                                <ul className="overview-strengths">

                                    <li>
                                        Smart classroom-based teaching
                                    </li>

                                    <li>
                                        Technology-supported learning
                                    </li>

                                    <li>
                                        IT infrastructure for modern education
                                    </li>

                                    <li>
                                        Digital resources to make lessons
                                        interactive and engaging
                                    </li>

                                </ul>

                            </div>


                            {/* 2. SCIENCE LABORATORIES */}

                            <div className="overview-section">

                                <div className="overview-section-heading">

                                    <h3>
                                        2. Science Laboratories
                                    </h3>

                                </div>

                                <p>
                                    The school has dedicated laboratories
                                    supporting practical learning in:
                                </p>

                                <ul className="overview-strengths">

                                    <li>Physics</li>

                                    <li>Chemistry</li>

                                    <li>Biology</li>

                                    <li>Mathematics</li>

                                    <li>Computer Science</li>

                                </ul>

                                <p>
                                    These facilities allow students to connect
                                    classroom concepts with hands-on
                                    experimentation.
                                </p>

                            </div>


                            {/* 3. COMPUTER & AI */}

                            <div className="overview-section">

                                <div className="overview-section-heading">

                                    <h3>
                                        3. Computer &amp; AI Learning
                                    </h3>

                                </div>

                                <p>
                                    The school provides computer/IT
                                    infrastructure and is developing
                                    technology-oriented learning, including AI
                                    and robotics-related education, helping
                                    students prepare for future academic and
                                    professional opportunities.
                                </p>

                            </div>


                            {/* 4. LIBRARY */}

                            <div className="overview-section">

                                <div className="overview-section-heading">

                                    <h3>
                                        4. Well-Equipped Library
                                    </h3>

                                </div>

                                <p>
                                    The school has a library supporting reading,
                                    research and self-learning, with books,
                                    reference materials, newspapers and
                                    magazines. Publicly available
                                    school-facility records list approximately
                                    3,500 books.
                                </p>

                            </div>


                            {/* 5. PLAYGROUND & SPORTS */}

                            <div className="overview-section">

                                <div className="overview-section-heading">

                                    <h3>
                                        5. Large Playground &amp; Sports Facilities
                                    </h3>

                                </div>

                                <p>
                                    A substantial open play area supports:
                                </p>

                                <ul className="overview-strengths">

                                    <li>
                                        Outdoor sports
                                    </li>

                                    <li>
                                        Indoor games
                                    </li>

                                    <li>
                                        Physical education
                                    </li>

                                    <li>
                                        Fitness activities
                                    </li>

                                    <li>
                                        Sports competitions and annual sports
                                        events
                                    </li>

                                </ul>

                            </div>


                            {/* 6. MUSIC DANCE CULTURAL */}

                            <div className="overview-section">

                                <div className="overview-section-heading">

                                    <h3>
                                        6. Music, Dance &amp; Cultural Facilities
                                    </h3>

                                </div>

                                <p>
                                    Students get opportunities to develop their
                                    creativity through:
                                </p>

                                <ul className="overview-strengths">

                                    <li>
                                        Music
                                    </li>

                                    <li>
                                        Dance
                                    </li>

                                    <li>
                                        Art and craft
                                    </li>

                                    <li>
                                        Cultural programmes
                                    </li>

                                    <li>
                                        Competitions and stage activities
                                    </li>

                                </ul>

                            </div>


                            {/* 7. TRANSPORT */}

                            <div className="overview-section">

                                <div className="overview-section-heading">

                                    <h3>
                                        7. Transport Facility 🚌
                                    </h3>

                                </div>

                                <p>
                                    School transportation is available to
                                    support students travelling from
                                    surrounding areas.
                                </p>

                            </div>


                            {/* 8. SAFETY & SECURITY */}

                            <div className="overview-section">

                                <div className="overview-section-heading">

                                    <h3>
                                        8. Safety &amp; Security
                                    </h3>

                                </div>

                                <p>
                                    The school provides security arrangements,
                                    including CCTV/security infrastructure,
                                    to maintain a safe learning environment
                                    for students.
                                </p>

                            </div>


                            {/* 9. HEALTH & MEDICAL */}

                            <div className="overview-section">

                                <div className="overview-section-heading">

                                    <h3>
                                        9. Health &amp; Medical Support
                                    </h3>

                                </div>

                                <p>
                                    Health and medical check-up facilities are
                                    provided for students, along with
                                    first-aid/health-support arrangements.
                                </p>

                            </div>


                            {/* 10. WATER & SANITATION */}

                            <div className="overview-section">

                                <div className="overview-section-heading">

                                    <h3>
                                        10. Safe Drinking Water &amp; Sanitation
                                    </h3>

                                </div>

                                <p>
                                    School facility records indicate
                                    availability of potable drinking water and
                                    separate sanitary facilities for boys and
                                    girls.
                                </p>

                            </div>


                            {/* SHORT VERSION */}

                            <div className="overview-section">
                                {/* HOLISTIC DEVELOPMENT */}

                                <div className="overview-highlight">

                                    <h3>
                                        🌱 HOLISTIC DEVELOPMENT
                                    </h3>

                                    <p>
                                        Beyond academics, NJMS provides
                                        opportunities in sports, yoga, arts, music,
                                        dance, competitions, exhibitions,
                                        Olympiads, educational activities and
                                        leadership development. The school's stated
                                        approach is to create a challenging yet
                                        supportive environment where students can
                                        develop academically and personally.
                                    </p>

                                </div>
                                {/* HOLISTIC DEVELOPMENT */}

                                <div className="overview-highlight">


                                    <h3>
                                        ✨ Short Version for your School Website
                                    </h3>
                                    <span>
                                        Our Facilities
                                    </span>


                                    <p>
                                        Nav Jeevan Mission School, Anandnagar
                                        provides a modern, safe and stimulating
                                        learning environment designed for the
                                        all-round development of every child. Our
                                        facilities include smart classrooms,
                                        well-equipped science and computer
                                        laboratories, AI and technology-based
                                        learning, a well-stocked library, spacious
                                        playgrounds, indoor games, music and dance
                                        facilities, transportation, health and
                                        medical support, safe drinking water,
                                        sanitation and security systems. Along with
                                        academic excellence, we provide ample
                                        opportunities in sports, arts, cultural
                                        activities, competitions and leadership
                                        development to help our students
                                        “Arise and Shine.”
                                    </p>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </main>

            <Footer />
        </>
    );
};

export default Facility;